import { contains3ue2qo8xhmpf1 as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance } from './Platform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_probablyAppleUser(_this__u8e3s4) {
  // Inline function 'kotlin.let' call
  var it = window.navigator.platform;
  return contains(it, 'Mac') || contains(it, 'iPhone') || contains(it, 'iPod') || contains(it, 'iPad');
}
function get_current(_this__u8e3s4) {
  return Platform_Web_getInstance();
}
function get_isDevelopment(_this__u8e3s4) {
  // Inline function 'kotlin.let' call
  var it = window.location.hostname;
  return it === 'localhost' || it === '127.0.0.1' || it === '0.0.0.0';
}
//region block: exports
export {
  get_current as get_current2r182tjucmm5v,
  get_isDevelopment as get_isDevelopment16qk6tv1fuxkk,
  get_probablyAppleUser as get_probablyAppleUser3bj8owedvq6si,
};
//endregion

//# sourceMappingURL=Platform.js.mjs.map
